import styled from 'styled-components';
import { COLOR_WHITE, COLOR_CV_6 } from 'constants/colors';
// import { Switch } from 'UI';

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${COLOR_WHITE};
  padding: 1.5rem;
`;

export const MainSectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${COLOR_WHITE};
  padding: 1.5rem;
`;

export const ProductSectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 1.5rem;
`;

export const ProductsTitle = styled.span`
  font-size: 1rem;
  font-weight: 700;
`;

export const ProductTypeContainer = styled.span`
  display: flex;
  flex-direction: column;
  padding-top: 1.5rem;
  align-items: flex-start;
`;

export const SwitchContainer = styled.div`
  margin-bottom: 0.75rem;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-bottom: 0.75rem;
  padding-top: 0.75rem;
`;

export const SwitchLabelContainer = styled.span`
  margin-left: 0.75rem;
  font-weight: 700;
  color: ${COLOR_CV_6}
`;
